import { createFilter } from "@omnia/shared/fields/filters/filters"
import { defineDirective, IOmniaSettings, IOmniaShell, Module, OmniaModuleId } from "../omnia"
import { IFieldsService, INutritionService } from "../types"
import { checkEnumValue } from "@omnia/shared/utils/utils"
import { NutritionVersionService } from "@omnia/shared/nutrition/version/service"

export enum NutritionView {
    Table = "table",
    Map = "map"
}

export class NutritionModule extends Module {

    static create(): ng.IDirective {
        return defineDirective(NutritionModule, "app/nutrition/module/module.html")
    }


    private settings: IOmniaSettings
    private _view: NutritionView

    static $inject = [
        "$scope",
        "OmniaNutritionService",
        "OmniaFieldsService",
        "OmniaShell",
        "OmniaNutritionVersion"
    ]

    constructor(
        $scope: ng.IScope,
        public readonly svc: INutritionService,
        private fieldSvc: IFieldsService,
        shell: IOmniaShell,
        private readonly version: NutritionVersionService) {

        super($scope, shell, "icon-nutrition", "Nutrition plans", OmniaModuleId.Nutrition)

    }

    $onInit() {

        this.settings = this.session.getSettings("nutrition2")


        this.register()
        this.start()

    }

    start() {

        this.refresh().then(() => {
            this.setInitialView()
        })

    }

    refresh() {
        return this.svc.refresh()
    }

    private register() {

        this.registerComponent("omnia-nutri-dashboard-map", {
            width: Number.POSITIVE_INFINITY
        })

        this.registerComponent("omnia-nutri-dashboard-table", {
            width: Number.POSITIVE_INFINITY
        })

        this._filter = createFilter(this.fieldSvc)

    }

    private setInitialView() {
        const s: NutritionView = this.settings.get("mainView")
        this.view = checkEnumValue(NutritionView, s) ? s : NutritionView.Map
    }

    get module(): Module {
        return this
    }

    get view() {
        return this._view
    }

    set view(view) {

        if (view != this._view) {

            let componentId = (view == NutritionView.Map ? "omnia-nutri-dashboard-map" : "omnia-nutri-dashboard-table")

            this.startComponent({ component: componentId, blocking: false }, true)

            this._view = view
            this.settings.set("mainView", view)

        }

    }

    hasActiveComponent() {
        const ctxt = this.getCurrentContext()
        return !ctxt
    }

    getViewSelectorLeft(): number {
        const cmp = this.hasActiveComponent()
        return (cmp ? 0 : 350)
    }

    get showUpgradeCmd() {
        const { svc } = this
        return (svc.yearId === 2025) && (!svc.readOnly) && (!this.hasActiveComponent())
    }

    startUpgrade() {
        this.shell.showComponentAsDialog("omnia-nutri-migration-dialog", null, {
            size: "md"
        })
    }

}
